const getLoaderState = (state) => state.schedule.loading;

const getSchedules = (state) => state.schedule.data;

const getModifiedSchedule = (state) => state.schedule.updateSchedule;

const runningSchedule = (state) => state.schedule.runningSchedule;

const getCalender = (state) => state.schedule.calender;

const getDayWiseSchedule = (state) => state.schedule.dayWiseSchedule;

const currentWatering = (state) => state.schedule.currentWatering;

const selectors = {
  getLoaderState,
  getSchedules,
  getModifiedSchedule,
  runningSchedule,
  getCalender,
  getDayWiseSchedule,
  currentWatering,
};

export default selectors;
